import { actionMenuItemIsActionable } from "../action-menu/internal/utils";
import { ACTION_GROUP_PARTS_DICTIONARY, ACTION_MENU_ITEM_EXPORT_PARTS, ACTION_MENU_ITEM_PARTS_DICTIONARY } from "../../common/reserved-names";
import { h } from "@stencil/core";
import { tokenMap } from "../../common/utils";
export const MARKER_CLASS = "marker";
export const MARKER_HIDDEN_CLASS = `${MARKER_CLASS}--hidden`;
export const MARKER_CLASS_SELECTOR = `.${MARKER_CLASS}`;
const EMPTY_DROPDOWN = undefined;
const renderItem = (item, itemIsVisible, marker, disabled, getImagePathCallback) => {
    const markerClasses = marker
        ? {
            [MARKER_CLASS]: true,
            [MARKER_HIDDEN_CLASS]: !itemIsVisible
        }
        : undefined;
    if (actionMenuItemIsActionable(item)) {
        return (h("ch-action-menu-render", { role: "listitem", id: marker?.id, class: markerClasses, disabled: disabled, getImagePathCallback: getImagePathCallback, exportparts: ACTION_MENU_ITEM_EXPORT_PARTS, blockAlign: item.itemsBlockAlign ?? "outside-end", inlineAlign: item.itemsInlineAlign ?? "inside-start", model: itemIsVisible ? item.items : EMPTY_DROPDOWN }, item.caption));
    }
    if (item.type === "separator") {
        return (h("hr", { id: marker?.id, class: markerClasses, part: tokenMap({
                [item.id]: !!item.id,
                [ACTION_MENU_ITEM_PARTS_DICTIONARY.SEPARATOR]: true,
                [ACTION_GROUP_PARTS_DICTIONARY.VERTICAL]: true,
                [item.parts]: !!item.parts
            }) }));
    }
    return marker ? (h("div", { role: "listitem", id: marker.id, class: markerClasses, style: !itemIsVisible ? { "inline-size": marker.size } : undefined }, itemIsVisible && h("slot", { name: item.id }))) : (h("slot", {
        // @ts-expect-error This error is a StencilJS's bug.
        // See https://developer.mozilla.org/en-US/docs/Web/HTML/Element/slot#attributes
        role: "listitem", name: item.id
    }));
};
const itemIsVisible = (responsiveCollapse, displayedMarkers, index) => !responsiveCollapse || displayedMarkers[index].displayed;
export const renderItems = (model, responsiveCollapse, displayedMarkers, disabled, getImagePathCallback) => model.map((item, index) => renderItem(item, itemIsVisible(responsiveCollapse, displayedMarkers, index), displayedMarkers ? displayedMarkers[index] : undefined, disabled, getImagePathCallback));
